export const GET_LEADS_PER_DAY_SUCCESS = 'GET_LEADS_PER_DAY_SUCCESS'
export const SET_FETCHING_LEADS_PER_DAY = 'SET_FETCHING_LEADS_PER_DAY'
export const SET_LEADS_PER_DAY_FILTERS = 'SET_LEADS_PER_DAY_FILTERS'
export const RESET_LEADS_PER_DAY_FILTERS = 'RESET_LEADS_PER_DAY_FILTERS'
